import { Box, LinearProgress, useTheme } from '@mui/material';

const IncPageLoader = ({
  loadingState = {},
  overlay = ['isLoading', 'isUninitialized'],
}) => {
  const { isLoading, isFetching, isUninitialized } = loadingState;
  const theme = useTheme();

  return (
    <>
      <LinearProgress
        sx={{
          position: 'sticky',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1101,
          visibility:
            isLoading || isFetching || isUninitialized ? 'visible' : 'hidden',
        }}
        data-testid="IncPageLoader.LinearProgress"
      />
      {overlay?.some(state => loadingState[state]) && (
        <Box
          position="absolute"
          top="4px"
          right={0}
          bottom={0}
          left={0}
          backgroundColor={`${theme.palette.background.default}55`}
          zIndex="modal"
          opacity={0.2}
          data-testid="IncPageLoader.Overlay"
        ></Box>
      )}
    </>
  );
};

export default IncPageLoader;
